import Swiper from 'swiper/bundle';
import { onReadyWidgetOfType } from '../utils/helper';

onReadyWidgetOfType("TabProperties", (widget, data) => {
    //console.log({ widget, data })
    const swiperElement = widget.querySelector(".tab-properties-widget-swiper")
    const secondarySwiperElement = widget.querySelector(".secondary-widget-swiper")

    /**
     * @type {import('swiper').Swiper}
     */
    var swiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        watchOverflow: true, // Enable this to hide navigation when all slides are visible
        navigation: {
            prevEl: '.tabprev',     
            nextEl: '.tabnext',
        },
    })

    var secondarySwiper = new Swiper(secondarySwiperElement, {
        slidesPerView: 'auto',
        spaceBetween: 20,
        watchOverflow: true, // Enable this to hide navigation when all slides are visible
    })


    function slideToActiveTab(containerSelector, swiperInstance) {
        const tabElement = widget.querySelector(`${containerSelector}`);
        if (tabElement) {
            const id = tabElement.id;
            const activeTab = id.split('-');
            const activeTabIndex = parseInt(activeTab[1], 10);
            if (activeTabIndex) {
                swiperInstance.slideTo(activeTabIndex, 200, true);
            }
        }
    }

    // Primary Tab
    slideToActiveTab('.tab-properties-widget-swiper .tabColActive', swiper);

    // Secondary tab
    slideToActiveTab('.smrtTab .col-auto .activeTab', secondarySwiper);
});